
/**
 * RelivConferenceOrderItemConverter
 * @constructor
 */
var RelivConferenceOrderItemConverter = function () {

    /**
     * self
     */
    var self = this;

    /**
     * convertToTicketItems
     * @param orderItems
     */
    self.convertToTicketItems = function (
        orderItems
    ) {
        var ticketItems = {};

        var featureItems = {};

        angular.forEach(
            orderItems,
            function (orderItem, key) {
                //
                var itemTickets = self.buildTicketsFromOrderItem(
                    orderItem,
                    ticketItems
                );
                angular.extend(ticketItems, itemTickets);

            }
        );

        angular.forEach(
            orderItems,
            function (orderItem, key) {
                //
                var itemFeatures = self.buildFeaturesFromOrderItem(
                    orderItem,
                    featureItems,
                    ticketItems
                );
                angular.extend(featureItems, itemFeatures);
            }
        );

        return self.buildTicketItemFeatures(ticketItems, featureItems);
    };

    /**
     * buildTicketsFromOrderItem
     * @param orderItem
     * @param ticketItems
     * @returns {*}
     */
    self.buildTicketsFromOrderItem = function (
        orderItem,
        ticketItems
    ) {
        if (ticketItems == undefined || typeof ticketItems !== 'object') {
            ticketItems = {};
        }

        if (orderItem.type == 'conferenceTicket') {
            angular.forEach(
                orderItem.data,
                function (ticket, key) {
                    ticket.type = orderItem.type;
                    ticket.skuNumber = orderItem.skuNumber;
                    ticket.featureData = [];
                    ticketItems[ticket.uid] = ticket;
                }
            );
        }

        return ticketItems;
    };

    /**
     * buildFeaturesFromOrderItem
     * @param orderItem
     * @param featureItems
     * @param ticketItems
     * @returns {*}
     */
    self.buildFeaturesFromOrderItem = function (
        orderItem,
        featureItems,
        ticketItems
    ) {
        if (featureItems == undefined || typeof featureItems !== 'object') {
            featureItems = {};
        }

        if (orderItem.type == 'conferenceFeature') {
            angular.forEach(
                orderItem.data,
                function (feature, key) {
                    // only add it there is a ticket (ticket will be tied to conferenceId)
                    if (ticketItems[feature.ticketUid]) {
                        feature.type = orderItem.type;
                        feature.skuNumber = orderItem.skuNumber;
                        feature.conferenceId = ticketItems[feature.ticketUid].conferenceId;

                        if (!featureItems[feature.ticketUid]) {
                            featureItems[feature.ticketUid] = [];
                        }
                        featureItems[feature.ticketUid].push(feature);
                    }
                }
            );
        }

        return featureItems;
    };

    /**
     * buildTicketItemFeatures
     * @param ticketItems
     * @param featureItems
     * @returns {*}
     */
    self.buildTicketItemFeatures = function (ticketItems, featureItems) {

        var ticketItemArray = [];

        angular.forEach(
            ticketItems,
            function (ticketItem, key) {
                if (featureItems[ticketItem.uid]) {
                    ticketItem.featureData = featureItems[ticketItem.uid];
                }
                ticketItemArray.push(ticketItem);
            }
        );

        return ticketItemArray;
    };
};

/**
 * relivConference.relivConferenceOrderItemConverter
 */
angular.module('relivConference').service(
    'relivConferenceOrderItemConverter',
    function () {
        return new RelivConferenceOrderItemConverter();
    }
);
